module.exports = __webpack_public_path__ + "static/media/Well.c2770883.svg";